export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-24 pb-32">
      <div className="max-w-[1440px] mx-auto px-20 w-full">
        <div className="flex items-center gap-16">
          {/* Left Content */}
          <div className="w-[45%] pt-12">
            <div className="uppercase text-xs font-semibold tracking-[3px] text-[#4A9FFF] mb-8">
              MOBILE INNOVATION
            </div>
            <h2 className="text-7xl font-bold leading-tight mb-10">
              <span className="text-[#1A1A1A]">Modern Applications</span>
              <br />
              <span className="text-[#2D2D2D] font-light">for iOS Platform</span>
            </h2>
            <p className="text-xl text-[#666666] leading-relaxed max-w-[520px]">
              FRENKI D.O.O. is a team of experts developing modern applications for the iOS platform. Our products, such as VPN and Cleaner, are designed to enhance user experience and improve the security of mobile devices.
            </p>
          </div>

          {/* Right Visual */}
          <div className="w-[55%]">
            <div className="relative rounded-[48px] bg-gradient-to-br from-[#E8F4FF] to-[#F5F9FF] p-16 shadow-[0_20px_60px_rgba(0,0,0,0.08)] overflow-hidden">
              <div className="relative w-full h-[600px] flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/e9eb80b8517e7d6531f2c2e1e19b1027.jpg"
                  alt="iOS Applications"
                  className="w-full h-full object-contain object-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}